export const FLAVOR_PRODUCTION = 'production';
export const FLAVOR_STAGING = 'staging';
export const FLAVOR_DEVELOPMENT = 'development';
